import React from 'react'
import { format, startOfWeek, endOfWeek } from 'date-fns'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiFileText, FiCalendar } = FiIcons

const WeeklyReport = ({ report, loading }) => {
  const currentWeek = {
    start: startOfWeek(new Date()),
    end: endOfWeek(new Date())
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="bg-green-100 p-2 rounded-lg">
            <SafeIcon icon={FiFileText} className="h-5 w-5 text-green-600" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Weekly Report</h3>
            <p className="text-sm text-gray-500 flex items-center space-x-1">
              <SafeIcon icon={FiCalendar} className="h-4 w-4" />
              <span>
                {format(currentWeek.start, 'MMM dd')} - {format(currentWeek.end, 'MMM dd, yyyy')}
              </span>
            </p>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-green-600"></div>
          <span className="ml-2 text-gray-600">Generating report...</span>
        </div>
      ) : report ? (
        <div className="space-y-6">
          {report.summary && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <p className="text-green-800 font-medium">Week Summary</p>
              <p className="text-green-700 mt-1">{report.summary}</p>
            </div>
          )}

          {report.recommendations && Array.isArray(report.recommendations) && (
            <div>
              <h4 className="font-semibold text-gray-900 mb-3">Recommendations for Next Week</h4>
              <div className="space-y-2">
                {report.recommendations.map((rec, index) => (
                  <div key={index} className="flex items-start space-x-3 p-3 bg-blue-50 rounded-lg">
                    <div className="bg-blue-100 p-1 rounded-full mt-1">
                      <SafeIcon icon={FiIcons.FiTarget} className="h-3 w-3 text-blue-600" />
                    </div>
                    <p className="text-blue-800 text-sm">{rec}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {typeof report === 'string' && (
            <div className="prose prose-sm max-w-none text-gray-700">
              <p>{report}</p>
            </div>
          )}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          <p>No weekly report available</p>
          <p className="text-sm mt-1">Trade more to get comprehensive weekly insights</p>
        </div>
      )}
    </div>
  )
}

export default WeeklyReport